(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stretch-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('icon-modal-opener')) {
    customElements.define(
      'icon-modal-opener',
      class IconModalOpener extends HTMLElement {
        constructor() {
          super()
          this.button = this.querySelector('button')
          this.init()
        }
        init() {
          this.button.addEventListener('click', this.toggleIconGlossary.bind(this))
        }
        toggleIconGlossary(e) {
          let iconGlossaryLink = document.querySelector('[data-heading="icon-glossary"]')
          if (iconGlossaryLink) {
            iconGlossaryLink.click()
          }
        }
      }
    )
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-radios"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('size-guide')) {
    customElements.define(
      'size-guide',
      class SizeGuide extends HTMLElement {
        constructor() {
          super()
          this.radioButtons = this.querySelectorAll('input[type=radio][name=measurement]')
          this.init()
        }
        init() {
          // all the toggle code
          this.radioButtons.forEach((button) => {
            button.addEventListener('change', this.updateTable.bind(this))
          })
        }

        updateTable(e) {
          this.targetValue = e.currentTarget.value
          this.querySelector('.checked').classList.remove('checked')
          e.currentTarget.classList.add('checked')
          this.activeTable = this.querySelector(`table#${this.targetValue}-table`)
          //whatever you need to do to update the table
          this.querySelector('.active').classList.add('hidden')
          this.querySelector('.active').classList.remove('active')
          if (this.activeTable.classList.contains('hidden')) {
            this.activeTable.classList.remove('hidden')
            this.activeTable.classList.add('active')
          }
        }
      }
    )
  }
  } catch(e) { console.error(e); }
})();

})();
